import DLAnimate from 'dl-animate/dist/dl-animate-module';
import createEvent from '@/scripts/utils/create-event';
import './Tabs.scss';

const defaults = {
  mainContainer: null,
  navItem: '[data-role*="tab-list-link"]',
  tabItem: '[data-role*="tab-list-target"]',
  activeClass: 'is-active',
  lineController: false,
};

export default class Tabs {
  constructor(props) {
    const options = Object.assign({}, defaults, props);
    this.mainContainer = options.mainContainer;
    this.navItem = options.navItem;
    this.tabItem = options.tabItem;
    this.activeClass = options.activeClass;
    this.navItems = Array.from(this.mainContainer.querySelectorAll(this.navItem));
    this.tabItems = Array.from(this.mainContainer.querySelectorAll(this.tabItem));
    this.navLine = options.navLine;
    this.lineController = options.lineController;
    this.animate = new DLAnimate();

    this.activeIndex = null;
    this.isAnimated = false;
    this.duration = document.documentElement.dataset.duration * 1000;
    this.init();
  }

  setAttribute() {
    this.navItems.forEach((item, i) => {
      item.dataset.index = i; // eslint-disable-line no-param-reassign
      this.tabItems[i].dataset.index = i;
      this.tabItems[i].classList.add('is-loaded');
    });
  }

  showActiveItem(newIndex) {
    this.animate.show(this.tabItems[newIndex], {
      name: 'tab',
      track: 'none',
      duration: this.duration,
      afterEnter: () => {
        this.isAnimated = false;
        this.activeIndex = newIndex;
      },
    });
  }
  changeTab(newIndex) {
    if (this.isAnimated || newIndex === this.activeIndex) return false;
    return this.animate.hide(this.tabItems[this.activeIndex], {
      name: 'tab',
      track: 'none',
      duration: this.duration,
      beforeLeave: () => {
        this.isAnimated = true;
        this.navItems[newIndex].classList.add(this.activeClass);
        this.navItems[this.activeIndex].classList.remove(this.activeClass);
        if (this.lineController) this.lineController.dispatchEvent(createEvent('updateLine'));
      },
      afterLeave: () => this.showActiveItem(newIndex),
    });
  }

  addEvents() {
    const that = this;
    this.navItems.forEach((item) => {
      item.addEventListener('click', function (e) { // eslint-disable-line func-names
        e.preventDefault();
        that.changeTab(this.dataset.index);
      });
    });
  }

  init() {
    if (!this.navItems.length || !this.tabItems.length) return;
    this.setAttribute();
    this.addEvents();
    this.showActiveItem(0);
    this.navItems[0].classList.add(this.activeClass);
    if (this.lineController) this.lineController.dispatchEvent(createEvent('updateLine'));
  }
}



// WEBPACK FOOTER //
// ./scripts/lib/Tabs/Tabs.js